import '@images/i-menu.png';

export default class {
  /**
   * Uncheck the 'Alert Email' checkbox after saving the post
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/packages/packages-data/#generic-stores
   * @link https://developer.wordpress.org/block-editor/reference-guides/data/data-core-editor/
   */
  boot() {
    if (window.wp === undefined || wp.data === undefined) {
      return;
    }

    const { select, subscribe } = wp.data;
    const editor = select('core/editor');
    const checkbox = document.getElementById('lcasAdminAlertEmail');

    if (!editor || !checkbox) {
      return;
    }

    var wasSaving = editor.isSavingPost() || editor.isAutosavingPost();
    var timer = 0;

    subscribe(() => {
      const isSaving = editor.isSavingPost() || editor.isAutosavingPost();
      const isDoneSaving = wasSaving && !isSaving;
      wasSaving = isSaving;

      if (isDoneSaving) {
        clearTimeout(timer);
        timer = setTimeout(() => (checkbox.checked = false), 2000);
      }
    });
  }
}
